import React, { useState } from 'react';
import { Cpu, FileCheck, ListChecks } from 'lucide-react';
import ArcWeldingCertificatesPage from './ArcWeldingCertificatesPage';
import ArcWeldingEquipmentProfilesPage from './ArcWeldingEquipmentProfilesPage';
import ArcWeldingCriteriaPage from './ArcWeldingCriteriaPage';
import './ArcWelding.css';

const AW_SUB_SECTIONS = [
  { id: 'certificates', label: 'Certificates', icon: FileCheck },
  { id: 'equipment', label: 'Equipment Profiles', icon: Cpu },
  { id: 'criteria', label: 'Verification Criteria', icon: ListChecks },
];

const ArcWeldingHubPage = () => {
  const [activeSection, setActiveSection] = useState('certificates');
  const [certificatesInForm, setCertificatesInForm] = useState(false);

  const showSubNav = !certificatesInForm;

  return (
    <div className="aw-hub-page">
      {showSubNav && (
        <div className="aw-hub-subnav">
          {AW_SUB_SECTIONS.map((section) => {
            const Icon = section.icon;
            return (
              <button
                key={section.id}
                type="button"
                className={`aw-hub-subnav-item${activeSection === section.id ? ' aw-hub-subnav-item--active' : ''}`}
                onClick={() => setActiveSection(section.id)}
              >
                <Icon size={16} aria-hidden />
                {section.label}
              </button>
            );
          })}
        </div>
      )}

      <div className="aw-hub-content">
        {activeSection === 'certificates' && (
          <ArcWeldingCertificatesPage onViewChange={setCertificatesInForm} />
        )}
        {activeSection === 'equipment' && <ArcWeldingEquipmentProfilesPage />}
        {activeSection === 'criteria' && <ArcWeldingCriteriaPage />}
      </div>
    </div>
  );
};

export default ArcWeldingHubPage;
